import React from 'react';
import {
  CheckSVG,
  CoverageSVG,
  CreditCardSVG,
  DirectionsCarSVG,
  DriverLicenseSVG,
  PersonSVG,
  PolicySVG,
  UserInfoSVG,
  AdditionalInterestsSVG,
  QuoteSVG,
  CoveragesSVG,
  HomeSVG,
  AddDriversAndVehiclesSVG,
} from '../components/svg';

const ProgressBarIcon = ({issues, valid, iconKey, index, currentStep, isMobile, hideNavLabels})=>{
  const icons = [
    {
      key: 'general',
      file: UserInfoSVG,
    },
    {
      key: 'underwritingQuestions',
      file: CoverageSVG,
    },
    {
      key: 'vehiclesAndDrivers',
      file: AddDriversAndVehiclesSVG,
    },
    {
      key: 'drivers',
      file: PersonSVG,
    },
    {
      key: 'vehicles',
      file: DirectionsCarSVG,
    },
    {
      key: 'quote',
      file: QuoteSVG,
    },
    {
      key: 'insured',
      file: UserInfoSVG,
    },
    {
      key: 'policy',
      file: PolicySVG,
    },
    {
      key: 'additionalInterests',
      file: AdditionalInterestsSVG,
    },
    {
      key: 'payment',
      file: CreditCardSVG,
    },
    {
      key: 'property',
      file: HomeSVG,
    },
    {
      key: 'coverages',
      file: CoveragesSVG,
    },
    {
      key: 'qualifications',
      file: CoverageSVG,
    },
  ];

  const determineIcon = (key, icons) => {
    return icons.find((icon) => {
      if (icon.key === key) {
        return icon;
      }
    });
  };

  const icon = determineIcon(iconKey,icons);

  const determineDisplayed = (issues, valid, icon, index, currentStep) => {
    const Check = () => (
        <div style={{ width: '16px', height: '16px' }}>
          <CheckSVG color={'#00abdd'} width={'16'} height={'16'} />
        </div>
    );

    const Icon = () => {
      let Component;
      Component = icon.file;
      return (
          <div
              style={{
                width: '16px',
                height: '16px',
                display: 'flex',
                justifyContent: 'center',
                alignSelf: 'center',
              }}
          >
            <Component height={'16'} width={'16'} color="#28333f" />
          </div>
      );
    };

    if (isMobile){
      const ErrorBadge = () => (
          <Popover
              content={
                <div>
                  {issues.map((issue) => (
                      <div key={issue}>{issue}</div>
                  ))}
                </div>
              }
              title="Validation Issues"
          >
            <Badge count={issues.length} />
          </Popover>
      );

      if (issues.length > 0) {
        return <ErrorBadge />;
      } else if (valid === true) {
        if (hideNavLabels === false) {
          return <Check />;
        }
        if (hideNavLabels && index === currentStep) {
          return <Check />;
        }
        return null;
      } else {
        if (hideNavLabels === false) {
          return <Icon />;
        }
        if (hideNavLabels && index === currentStep) {
          return <Icon />;
        }
        return null;
      }
    }else {
      if (valid === true) {
        return <Check />;
      } else {
        return <Icon />;
      }
    }
  };

  return determineDisplayed(issues, valid, icon, index, currentStep);
}

export default ProgressBarIcon;